import { Text, Card, Group, Button } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { useRef } from "react";
import { NavLink } from "react-router-dom";
import RefreshQueryButton from "@/components/refresh-query-button";
import { THandler } from "@/components/table/Table";
import { useGetAuthorizations } from "@/hooks/useGetAuthorizations";
import EmbaixadoresPessoasTable from "@/modules/embaixadores-pessoas/components/embaixadores-pessoas-table";
import { EMBAIXADORES_PESSOAS_COLLECTION_KEY } from "@/modules/embaixadores-pessoas/firestore";
import { ID_CADASTROS_EMBAIXADORES } from "@/utils/constants";

const REFRESH_ALL_KEY = [...EMBAIXADORES_PESSOAS_COLLECTION_KEY] as const;

const EmbaixadoresPage = () => {
  const tableHandlersReference = useRef<THandler<TEmbaixadorPessoa>>(null);
  const { create } = useGetAuthorizations(ID_CADASTROS_EMBAIXADORES);

  return (
    <Card
      withBorder
      shadow="md"
      styles={{
        section: {
          overflow: "auto"
        }
      }}
    >
      <Card.Section px="md" py="xs" withBorder>
        <Group justify="space-between">
          <Text fw={500} fz="lg">
            Listagem de Embaixadores
          </Text>
          {create ? (
            <Group>
              <Button size="sm" leftSection={<IconPlus size="1rem" />} component={NavLink} to="/embaixadores/novo">
                Adicionar Embaixador
              </Button>
            </Group>
          ) : (
            <></>
          )}
        </Group>
      </Card.Section>

      <Card.Section inheritPadding py="md" withBorder>
        <Group justify="flex-end">
          <RefreshQueryButton queryKey={REFRESH_ALL_KEY} />
        </Group>
      </Card.Section>

      <EmbaixadoresPessoasTable ref={tableHandlersReference} />
    </Card>
  );
};

export default EmbaixadoresPage;
